import React, { Component } from 'react';
import DailyConvData from '../dailyReports/DailyConvData';
import DailyPerformData from '../dailyReports/DailyPerformData';
import { Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';

class DailyReportTab extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/reports/statistics/dailyConvdata";
            var path1 = window.origin + "/platform/projectmgmt/reports/statistics/dailyConvdata/";
            if (currentPath === path || currentPath === path1) {
                $("#daily-conv-data").addClass('active');
            } else if (currentPath.includes('/statistics/dailyConvdata/dailyperformdata')) {
                $("#daily-perform-data").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-used-daily-report-tab")).addClass('active')
            }

            $("#daily-conv-data,#daily-perform-data")
                .on("click", function () {
                    $("#daily-conv-data,#daily-perform-data")
                        .removeClass('active');
                    localStorage.setItem("last-used-daily-report-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs navCluster">
                                <Link to="/projectmgmt/reports/statistics/dailyConvdata" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="daily-conv-data">
                                        Conversation Analytics
                                    </li>
                                </Link>
                                <Link to="/projectmgmt/reports/statistics/dailyConvdata/dailyperformdata" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="daily-perform-data">
                                        Performance Analytics
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/reports/statistics/dailyConvdata/dailyperformdata" component={DailyPerformData}></Route>
                    <Route path="/projectmgmt/reports/statistics/dailyConvdata" component={DailyConvData}></Route>
                </Switch>
            </div >
        )
    }
}
export default DailyReportTab;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/dailyReports/DailyReportTab.js